export default __webpack_public_path__ + "static/762-c55f8909da8efcfd0c70daa0a8dc25eb.gif";